/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_V1_Projection_Savings_LabelInputs */

const en_onboarding_v1_projection_savings_label = /** @type {(inputs: Onboarding_V1_Projection_Savings_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Savings account`)
};

const de_onboarding_v1_projection_savings_label = /** @type {(inputs: Onboarding_V1_Projection_Savings_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sparkonto`)
};

const pt_br2_onboarding_v1_projection_savings_label = /** @type {(inputs: Onboarding_V1_Projection_Savings_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conta poupança`)
};

const tr_onboarding_v1_projection_savings_label = /** @type {(inputs: Onboarding_V1_Projection_Savings_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tasarruf hesabı`)
};

const zh_cn2_onboarding_v1_projection_savings_label = /** @type {(inputs: Onboarding_V1_Projection_Savings_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`储蓄账户`)
};

const zh_hk2_onboarding_v1_projection_savings_label = /** @type {(inputs: Onboarding_V1_Projection_Savings_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`儲蓄賬戶`)
};

const ko_kr2_onboarding_v1_projection_savings_label = /** @type {(inputs: Onboarding_V1_Projection_Savings_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`저축 계좌`)
};

const ru_ru2_onboarding_v1_projection_savings_label = /** @type {(inputs: Onboarding_V1_Projection_Savings_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сберегательный счёт`)
};

const es_419_onboarding_v1_projection_savings_label = /** @type {(inputs: Onboarding_V1_Projection_Savings_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cuenta de ahorros`)
};

/**
* | output |
* | --- |
* | "Savings account" |
*
* @param {Onboarding_V1_Projection_Savings_LabelInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const onboarding_v1_projection_savings_label = /** @type {((inputs?: Onboarding_V1_Projection_Savings_LabelInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_V1_Projection_Savings_LabelInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onboarding_v1_projection_savings_label(inputs)
	if (locale === "de") return de_onboarding_v1_projection_savings_label(inputs)
	if (locale === "pt-BR") return pt_br2_onboarding_v1_projection_savings_label(inputs)
	if (locale === "tr") return tr_onboarding_v1_projection_savings_label(inputs)
	if (locale === "zh-CN") return zh_cn2_onboarding_v1_projection_savings_label(inputs)
	if (locale === "zh-HK") return zh_hk2_onboarding_v1_projection_savings_label(inputs)
	if (locale === "ko-KR") return ko_kr2_onboarding_v1_projection_savings_label(inputs)
	if (locale === "ru-RU") return ru_ru2_onboarding_v1_projection_savings_label(inputs)
	return es_419_onboarding_v1_projection_savings_label(inputs)
});